module.exports = __webpack_public_path__ + "static/Cli-c96fe18fb8ebc61a66ec530a8bdb87ef.svg";